import { formatBankId, formatDateValue, formatDecimalPrice, formatPhone, GetMonthNameFromNum } from "src/app/shared/utils/utils";
import { Setting } from "../../employee/employee-deduction";
import { get } from "lodash";
import { columnKeyTh, ProfileSetting } from "../../employee/employee";
import { formatAddress } from "src/app/shared/utils/utils-address";

export interface TabItems {
  value: string | number;
  label: string;
  items?: TabItems[];
}
export interface TabItemWithIcon extends TabItems {
  icon: string;
  totalKey: string;
}

export const StatusTab: TabItemWithIcon[] = [{
  value: 'waiting',
  label: 'Requests',
  icon: 'fa-bell',
  totalKey: 'number_requests'
}, {
  value: 'completed',
  label: 'Completed',
  icon: 'fa-check',
  totalKey: 'number_completed'
}];

export const NotificationLinks = [{
  title: 'All',
  fragment: 'all',
  totalKey: 'number_all'
}, {
  title: 'ค่าลดหย่อน',
  fragment: 'deduction_info',
  totalKey: 'number_deduction'
}, {
  title: 'เงินพิเศษ',
  fragment: 'extra_income',
  totalKey: 'number_extra_payments'
}, {
  title: 'ลา / ขาดงาน',
  fragment: 'absence',
  totalKey: 'number_absence'
}, {
  title: 'ข้อมูลส่วนตัว',
  fragment: 'personal_info',
  totalKey: 'number_personal_info'
}];

export enum NotiFilters {
  waiting = 'waiting',
  completed = 'completed'
}

export enum NotiTypes {
  all = 'all',
  deduction = 'deduction',
  extramoney = 'extramoney',
  absent = 'absent',
  information = 'information'
}


export enum NotiSubmitStatus {
  cancel = 'cancel',
  waiting = 'waiting',
  approved = 'approved',
  rejected = 'rejected',
  approved_with_conditions = 'approved_with_conditions',
  voided = 'voided',
  forward = 'forward'
}

export const ImageKey = ['id_card_file', 'house_registration_file', 'bank_book_file'];
export const ImageLabel = {
  id_card_file: 'บัตรประชาชน',
  house_registration_file: 'ทะเบียนบ้าน',
  bank_book_file: 'Bookbank'
};

export const NotiStatus = {
  waiting: {
    label: 'รอตรวจสอบ',
    subLabel: 'รอตรวจสอบ',
    labelEn: 'Waiting',
    color: '#1388ff',
    dotColor: '#1388ff',
    bgColor: '#1388ff',
    textStatusColor: '#1388ff',
    icon: '',
    stamp: '',
  },
  rejected: {
    label: 'ปฏิเสธ',
    subLabel: 'ถูกปฏิเสธ',
    labelEn: 'Rejected',
    color: '#f95d9e',
    dotColor: '#f95d9e',
    bgColor: '#fcedf3',
    textStatusColor: '#f95d9e',
    icon: '/assets/app/ico-warning.svg',
    stamp: '/assets/icons/stamp-rejected.png',
  },
  cancel: {
    label: 'ยกเลิก',
    subLabel: 'ยกเลิก',
    labelEn: 'Cancel',
    color: '#a7b2ac',
    dotColor: '#dae5df',
    bgColor: '#dae5df',
    textStatusColor: '#a7b2ac',
    icon: '/assets/app/ico-warning.svg',
    stamp: '',
  },
  approved: {
    label: 'สำเร็จ',
    subLabel: 'สำเร็จ',
    labelEn: 'Approved',
    color: '#01b266',
    dotColor: '#01b266',
    bgColor: '#e8f8ee',
    textStatusColor: '#01b266',
    icon: '',
    stamp: '/assets/icons/stamp-approved.png',
  },
  approved_with_conditions: {
    label: 'โปรดตรวจสอบ',
    subLabel: 'ได้รับอนุมัติ และปฏิเสธบางรายการ',
    labelEn: 'Approved & Rejected',
    color: '#d59d00',
    dotColor: '#ffae54',
    bgColor: '#f9f4cc',
    textStatusColor: '#c88313',
    icon: '/assets/app/img-warning.svg',
    stamp: '/assets/icons/stamp-approved-rejected.png',
  },
  voided: {
    label: 'Voided',
    subLabel: 'Voided',
    labelEn: 'Voided',
    color: '#a7b2ac',
    dotColor: '#a7b2ac',
    bgColor: '#f6f7f7',
    textStatusColor: '#a7b2ac',
    icon: '/assets/app/ico-warning.svg',
    stamp: '/assets/icons/stamp-voided.png',
  },
  forward: {
    label: 'Forwarded',
    subLabel: 'Forwarded',
    labelEn: 'Forwarded',
    color: '#a7b2ac',
    dotColor: '#a7b2ac',
    bgColor: '#f6f7f7',
    textStatusColor: '#a7b2ac',
    icon: '/assets/app/ico-warning.svg',
    stamp: '/assets/icons/stamp-forwarded.png',
  },
};

export const NotiType = {
  personal_info_about: {
    label: 'ข้อมูลส่วนตัว',
    icon: '/assets/app/ico-smiley.svg'
  },
  personal_info_employment: {
    label: 'ข้อมูลส่วนตัว',
    icon: '/assets/app/ico-smiley.svg'
  },
  personal_info_contact: {
    label: 'ข้อมูลส่วนตัว',
    icon: '/assets/app/ico-smiley.svg'
  },
  deduction_info: {
    label: 'ค่าลดหย่อน',
    icon: '/assets/app/ico-picco-line.svg'
  },
  extra_income: {
    label: 'เงินพิเศษ',
    icon: '/assets/app/ico-money.svg'
  },
  absence: {
    label: 'ลา / ขาดงาน',
    icon: '/assets/app/ico-sun.svg'
  }
};

export const NotiSelfOnboardEmploymentSettings: Setting[] = [
  {
    title: '',
    subTitle: 'การจ้างงาน',
    field: 'employment_type'
  },
  {
    title: '',
    subTitle: 'เริ่มงาน',
    customValue: (datasource) => (
      formatDateValue(get(datasource, 'start_date')) || '-'
    )
  },
  {
    title: '',
    subTitle: 'วันทำงานวันสุดท้าย',
    customValue: (datasource) => (
      formatDateValue(get(datasource, 'end_date')) || '-'
    ),
    showLine: true,
  },
  {
    title: '',
    subTitle: 'วันที่เข้าประกันสังคม',
    customValue: (datasource) => {
      return formatDateValue(get(datasource, 'sso_start_date')) || '-'
    }
  },
  {
    title: '',
    subTitle: 'เลขบัตรประกันสังคม',
    customValue: (datasource) => {
      return get(datasource, 'sso_id_card') || '-';
    }
  },
  {
    title: '',
    subTitle: 'รหัสพนักงาน',
    field: 'employment_id'
  },
  {
    title: '',
    subTitle: 'แผนก',
    field: 'employment_id'
  },
  {
    title: '',
    subTitle: 'ทีม',
    field: 'employment_id'
  },
  {
    title: '',
    subTitle: 'ตำแหน่ง',
    field: 'employment_id'
  },
  {
    title: 'Payment',
    subTitle: 'ธนาคาร',
    field: 'bank_id',
    customValue: (datasource) => (
      get(datasource, 'bank_id') ? get(datasource, 'bank_id').toUpperCase(): '-'
    )
  },
  {
    title: '',
    subTitle: 'เลขบัญชี',
    customValue: (datasource) => (
      formatBankId(get(datasource, 'bank_account'))
    )
  },
  {
    title: '',
    subTitle: 'ชื่อตามสมุดบัญชี',
    field: 'bank_account_name'
  }
];

export const GetExceedAbsenceLabel = (datasource) => {
  const warning = datasource?.detail?.warning;
  if (warning) {
    const carryData = warning.filter(d => !!d.carry_limit);
    const overData = warning.filter(d => !d.carry_limit);

    if (carryData.length <= 0 && overData.length === 1) {
      const startDate = new Date(datasource?.detail?.start_date);
      const endDate = new Date(datasource?.detail?.end_date);
      if (startDate?.getFullYear() !== endDate?.getFullYear()) {
        return `<div class="d-flex w-50"><div>•</div><div class="ml-1">${overData[0]?.year} (เหลือ ${overData[0]?.quota_left} วัน)</div></div>`;
      }
      return `(เหลือ ${overData[0]?.quota_left} วัน)`
    } else {

      let html = '';
      let index = 0;
      if (carryData.length > 0) {
        carryData.forEach((d) => {
          const isRow = index % 2 === 0
          if (isRow) {
            if (index !== 0) {
              html += '</div>';
            }
            html += '<div class="d-flex">';
          }
          
          const limitDate = formatDateValue(d.carry_limit)
          html += `<div class="d-flex w-50"><div>•</div><div class="ml-1">Carryover ${d.quota_left} วัน ใช้ได้ถึง ${limitDate}</div></div>`;

          index++;
        });
      }

      overData.forEach((d) => {
        const isRow = index % 2 === 0
        if (isRow) {
          if (index !== 0) {
            html += '</div>';
          }
          html += '<div class="d-flex">';
        }
        html += `<div class="d-flex w-50"><div>•</div><div class="ml-1">${GetMonthNameFromNum(d.month)} ${d.year} (เหลือ ${d.quota_left} วัน)</div></div>`;
        index++;
      })
      html += '</div>';
      return html;
    }
  }
  return '';
}

export const IsExceedLeave = (datasource) => {
  const warning = datasource?.detail?.warning;
  return warning && warning.length > 0;
}

export const ConvertDecimalToTime = (decimal) => {
  const parts = decimal.toString().split(".");
  const hours = parseInt(parts[0], 10);
  const minutes = parts[1] ? parseInt(parts[1].padEnd(2, '0'), 10) : 0;

  let result = '';
  if (hours > 0) result += `${hours}h`;
  if (minutes > 0) result += (result ? ' ' : '') + `${minutes}m`;
  if (result === '') result = '0m';

  return result;
}

export const AboutMapData: ProfileSetting[] = [
  {
    title: 'คำนำหน้า',
    subTitle: 'title',
    field: 'title'
  }, {
    title: 'ชื่อจริง',
    subTitle: 'first_name',
    field: 'first_name'
  }, {
    title: 'นามสกุล',
    subTitle: 'last_name',
    field: 'last_name'
  }, {
    title: 'ชื่อเล่น',
    subTitle: 'nickname',
    field: 'nickname'
  }, {
    title: 'Title',
    subTitle: 'title_en',
    field: 'title_en'
  }, {
    title: 'First name',
    subTitle: 'first_name_en',
    field: 'first_name_en'
  }, {
    title: 'Last name',
    subTitle: 'last_name_en',
    field: 'last_name_en'
  }, {
    title: 'วันเกิด',
    subTitle: 'birth_date',
    customValue: (datasource) => (
      formatDateValue(get(datasource, 'birth_date'))
    )
  }, {
    title: 'เพศ',
    subTitle: 'sex',
    showLine: false,
    field: 'sex'
  }, {
    title: 'สถานภาพ',
    subTitle: 'marital_status',
    showLine: false,
    field: 'marital_status'
  }, {
    title: 'พิการ/ทุพพลภาพ',
    subTitle: 'disability_status',
    showLine: false,
    field: 'disability_status'
  }
]

export const ContactMapData: ProfileSetting[] = [
  {
    title: 'ที่อยู่ตามบัตรประชาชน',
    subTitle: 'id_card_address',
    customValue: (datasource) => (
      formatAddress(datasource.id_card_address) || '-'
    ),
  }, {
    title: 'ที่อยู่ที่สามารถติดต่อได้',
    subTitle: 'contact_address',
    customValue: (datasource) => (
      formatAddress(datasource.contact_address) || '-'
    ),
  }, {
    title: 'Email บริษัท',
    subTitle: 'company_email',
    field: 'company_email'
  }, {
    title: 'Email ส่วนตัว',
    subTitle: 'personal_email',
    field: 'personal_email',
  }, {
    title: 'โทรศัพท์ 1',
    subTitle: 'phone1',
    customValue: (datasource) => (
      formatPhone(datasource?.phone1)
    )
  }, {
    title: 'โทรศัพท์ 2',
    subTitle: 'phone2',
    customValue: (datasource) => (
      formatPhone(datasource?.phone2)
    )
  }, {
    title: 'ชื่อ (ติดต่อกรณีฉุกเฉิน)',
    subTitle: 'emergency_contact_person',
    field: 'emergency_contact_person'
  }, {
    title: 'เบอร์ (ติดต่อกรณีฉุกเฉิน)',
    subTitle: 'emergency_contact_no',
    customValue: (datasource) => (
      formatPhone(datasource?.emergency_contact_no)
    )
  }, {
    title: 'ความสัมพันธ์ (ติดต่อกรณีฉุกเฉิน)',
    subTitle: 'emergency_contact_relationship',
    field: 'emergency_contact_relationship'
  }];

export const EmploymentMapData: ProfileSetting[] = [
  {
    title: 'ธนาคาร',
    subTitle: 'bank_id',
    field: 'bank_id',
    customValue: (datasource) => (
      get(datasource, 'bank_id') ? get(datasource, 'bank_id').toUpperCase(): '-'
    )
  }, {
    title: 'เลขบัญชี',
    subTitle: 'bank_account',
    customValue: (datasource) => (
      formatBankId(get(datasource, 'bank_account'))
    )
  }, {
    title: 'ชื่อตามสมุดบัญชี',
    subTitle: 'bank_account_name',
    field: 'bank_account_name'
  }
]

export const DeductionMapData: ProfileSetting[] = [
  //   {
  //   title: 'พิการ/ทุพพลภาพ',
  //   subTitle: 'disability',
  //   customValue: (datasource) => datasource.disability?.amount ?
  //     '฿' + formatDecimalPrice(Number(this.getValue(datasource, 'disability.amount'))) :
  //     '-'
  // },
  {
    title: 'ค่าลดหย่อน - พ่อ',
    subTitle: 'deduction_father',
    customValue: (datasource) => datasource.deduction_father?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_father.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - แม่',
    subTitle: 'deduction_mother',
    customValue: (datasource) => datasource.deduction_mother?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_mother.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - คู่สมรส',
    subTitle: 'deduction_spouse',
    customValue: (datasource) => datasource.deduction_spouse?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_spouse.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - พ่อของคู่สมรส',
    subTitle: 'deduction_spouse_father',
    customValue: (datasource) => datasource.deduction_spouse_father?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_spouse_father.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - แม่ของคู่สมรส',
    subTitle: 'deduction_spouse_mother',
    customValue: (datasource) => datasource.deduction_spouse_mother?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_spouse_mother.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - บุตร 1',
    subTitle: 'deduction_child1',
    customValue: (datasource) => datasource.deduction_child1?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_child1.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - บุตร 2',
    subTitle: 'deduction_child2',
    customValue: (datasource) => datasource.deduction_child2?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_child2.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - บุตร 3',
    subTitle: 'deduction_child3',
    customValue: (datasource) => datasource.deduction_child3?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_child3.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - บุตร 4',
    subTitle: 'deduction_child4',
    customValue: (datasource) => datasource.deduction_child4?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_child4.birth_date')) :
      '-'
  }, {
    title: 'ค่าลดหย่อน - บุตร 5',
    subTitle: 'deduction_child5',
    customValue: (datasource) => datasource.deduction_child5?.birth_date ?
      'วันเกิด ' + formatDateValue(get(datasource, 'deduction_child5.birth_date')) :
      '-'
  }, {
    title: 'ประกันชีวิตทั่วไป',
    subTitle: 'life_insurance',
    customValue: (datasource) => (
      datasource?.life_insurance ? '฿' + formatDecimalPrice(datasource?.life_insurance) : '-'
    )
  }, {
    title: 'ประกันชีวิตทั่วไป - คู่สมรส',
    subTitle: 'life_insurance_spouse',
    customValue: (datasource) => (
      datasource?.life_insurance_spouse ? '฿' + formatDecimalPrice(datasource?.life_insurance_spouse) : '-'
    )
  }, {
    title: 'ประกันชีวิตแบบบำนาญ',
    subTitle: 'pension_life_insurance',
    customValue: (datasource) => (
      datasource?.pension_life_insurance ? '฿' + formatDecimalPrice(datasource?.pension_life_insurance) : '-'
    )
  }, {
    title: 'ประกันสุขภาพ - ตนเอง',
    subTitle: 'health_insurance',
    customValue: (datasource) => (
      datasource?.health_insurance ? '฿' + formatDecimalPrice(datasource?.health_insurance) : '-'
    )
  }, {
    title: 'ประกันสุขภาพ - พ่อ',
    subTitle: 'health_insurance_father',
    customValue: (datasource) => (
      datasource?.health_insurance_father ? '฿' + formatDecimalPrice(datasource?.health_insurance_father) : '-'
    )
  }, {
    title: 'ประกันสุขภาพ - แม่',
    subTitle: 'health_insurance_mother',
    customValue: (datasource) => (
      datasource?.health_insurance_mother ? '฿' + formatDecimalPrice(datasource?.health_insurance_mother) : '-'
    )
  }, {
    title: 'ประกันสุขภาพ - พ่อของคู่สมรส',
    subTitle: 'health_insurance_spouse_father',
    customValue: (datasource) => (
      datasource?.health_insurance_spouse_father ? '฿' + formatDecimalPrice(datasource?.health_insurance_spouse_father) : '-'
    )
  }, {
    title: 'ประกันสุขภาพ - แม่ของคู่สมรส',
    subTitle: 'health_insurance_spouse_mother',
    customValue: (datasource) => (
      datasource?.health_insurance_spouse_mother ? '฿' + formatDecimalPrice(datasource?.health_insurance_spouse_mother) : '-'
    )
  }, {
    title: 'RMF',
    subTitle: 'rmf',
    customValue: (datasource) => (
      datasource?.rmf ? '฿' + formatDecimalPrice(datasource?.rmf) : '-'
    )
  }, {
    title: 'SSF',
    subTitle: 'ssf',
    customValue: (datasource) => (
      datasource?.ssf ? '฿' + formatDecimalPrice(datasource?.ssf) : '-'
    )
  }, {
    title: 'Thai ESG',
    subTitle: 'tesg',
    customValue: (datasource) => (
      datasource?.tesg ? '฿' + formatDecimalPrice(datasource?.tesg) : '-'
    )
  }, {
    title: 'ดอกเบี้ยบ้าน',
    subTitle: 'house_interest',
    customValue: (datasource) => (
      datasource?.house_interest ? '฿' + formatDecimalPrice(datasource?.house_interest) : '-'
    )
  }, {
    title: 'บริจาคพรรคการเมือง',
    subTitle: 'donation.donate3',
    id: 'donate3',
    customValue: (datasource) => (
      datasource?.donation?.donate3 ? '฿' + formatDecimalPrice(datasource?.donation?.donate3) : '-'
    )
  }, {
    title: 'บริจาคพิเศษ - การศึกษา, กีฬา, โรงเรียน',
    subTitle: 'donation.donate2',
    id: 'donate2',
    customValue: (datasource) => (
      datasource?.donation?.donate2 ? '฿' + formatDecimalPrice(datasource?.donation?.donate2) : '-'
    )
  }, {
    title: 'บริจาคทั่วไป',
    subTitle: 'donation.donate1',
    id: 'donate1',
    customValue: (datasource) => (
      datasource?.donation?.donate1 ? '฿' + formatDecimalPrice(datasource?.donation?.donate1) : '-'
    )
  }, {
    title: '',
    subTitle: '',
    field: 'other'
  }
]

export const ExtraMapData: ProfileSetting[] = [
  {
    title: 'ค่าคอมมิชชั่น',
    subTitle: 'commission',
    customValue: (datasource) => '฿' + (datasource?.amount ? formatDecimalPrice(datasource?.amount): formatDecimalPrice(datasource?.commission)),
  }, {
    title: 'ค่าทำงานวันหยุด',
    subTitle: 'holiday',
    customValue: (datasource) => {
        if (datasource.holiday) {
            return datasource.holiday?.time ? formatDecimalPrice(datasource.holiday.time) + ' ชม.' : '฿' + formatDecimalPrice(datasource.holiday.amount)
        }
        return datasource?.time ? formatDecimalPrice(datasource.time) + ' ชม.' : '฿' + formatDecimalPrice(datasource.amount)
    }
  }, {
    title: 'OT ค่าล่วงเวลา',
    subTitle: 'ot',
    customValue: (datasource) => {
        if (datasource.ot) {
            return datasource.ot?.time ? formatDecimalPrice(datasource.ot.time) + ' ชม.' : '฿' + formatDecimalPrice(datasource.ot.amount)
        }
        return datasource?.time ?
      formatDecimalPrice(datasource.time) + ' ชม.' :
      '฿' + formatDecimalPrice(datasource.amount)
    }
  }, {
    title: 'OT ค่าล่วงเวลาวันหยุด',
    subTitle: 'ot_holiday',
    customValue: (datasource) => {
        if (datasource.ot_holiday) {
            return datasource.ot_holiday?.time ? formatDecimalPrice(datasource.ot_holiday.time) + ' ชม.' : '฿' + formatDecimalPrice(datasource.ot_holiday.amount)
        }
        return datasource?.time ?
      formatDecimalPrice(datasource.time) + ' ชม.' :
      '฿' + formatDecimalPrice(datasource.amount)
    }
  }, {
    title: 'ค่าโทรศัพท์',
    subTitle: 'phone_bill',
    customValue: (datasource) => '฿' + (datasource?.amount ? formatDecimalPrice(datasource?.amount): formatDecimalPrice(datasource?.phone_bill)),
  }, {
    title: 'ค่าน้ำมัน',
    subTitle: 'oil_cost',
    customValue: (datasource) => '฿' + (datasource?.amount ? formatDecimalPrice(datasource?.amount): formatDecimalPrice(datasource?.oil_cost)),
  }, {
    title: 'ค่าเดินทาง',
    subTitle: 'travel_expense',
    customValue: (datasource) => '฿' + (datasource?.amount ? formatDecimalPrice(datasource?.amount): formatDecimalPrice(datasource?.travel_expense)),
  }, {
    title: 'เงินสำรองจ่าย',
    subTitle: 'reserved_payment',
    customValue: (datasource) => '฿' + (datasource?.amount ? formatDecimalPrice(datasource?.amount): formatDecimalPrice(datasource?.reserved_payment)),
  }, {
    title: 'หมายเหตุ',
    subTitle: 'note',
    field: 'note',
  }
]

export const ExtraHourlyMapData: ProfileSetting[] = [
  {
    title: 'ประเภท',
    subTitle: 'extra_income_type',
    customValue: (datasource) => ( columnKeyTh[datasource.extra_income_type] || '-')
  }, {
    title: 'วันที่',
    subTitle: 'extra_income_date',
    customValue: (datasource) => formatDateValue(datasource?.extra_income_date)
  }, {
    title: 'เวลา',
    subTitle: 'time',
    customValue: (datasource) => {
        return `${datasource?.start_time} - ${datasource?.end_time} (${ConvertDecimalToTime(datasource?.time)})`
    }
  }, {
    title: 'ทำจ่าย',
    subTitle: 'month',
    customValue: (datasource) => {
      const m = parseInt(datasource?.month)
      return `${GetMonthNameFromNum(m)} ${datasource?.year}`
    },
    customHidden: (datasource) => {
      return !datasource.month || !datasource.year;
    }
  }, {
    title: 'หมายเหตุ',
    subTitle: 'note',
    field: 'note',
  }
]
